import React from 'react';
import PillarPageTemplate from '../../components/PillarPageTemplate';
import { passerelleA2AData } from '../../data/pillars/passerelleA2A';

export default function PillarPasserelleA2A() {
  return <PillarPageTemplate data={passerelleA2AData} />;
}
